/* eslint-disable sonarjs/cognitive-complexity */
import * as React from 'react';
import '../../../table/table.less';
import { Checkbox } from '../../../../../components';
import { CoreHelper, WithCoreProps } from 'ff-shared-components-core';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { TableColumn, ColType } from '../../../table';

export interface InputsRowProps {
	/**Set a row to be used on details click */
	row?: any;
	/**Set a row id to be used on details click */
	rowId: string;
	/**Set the row columns  */
	columns?: TableColumn[];
	/**sets an array of widths to render the table */
	columnsWidth?: ColType[];
	/**Set a checkbox(prefix) */
	withCheckbox?: boolean;
	/**Sets an image  prefix for the row */
	rowImage?: string;
	/**Set an image(prefix) */
	withImage?: boolean;
	/**Set a suffix to the row */
	withSuffix?: boolean;
	/**Sets a empty column at the end of table*/
	withEmptySpaceSuffix?: boolean;
	/**Set a pathToRedirect on details image click */
	pathToRedirect?: string;
	/**Sets if the checkbox is checked or not */
	isChecked?: boolean;
	/** Set text bold type */
	isBold?: boolean;
	/**sets the state of the row selection */
	isSelected?: boolean;
	/**Set an event to be handled when the checkbox is clicked */
	onClick?: (e?: any) => void;
	/**Sets an event to be handled on details click */
	onDetailsClick?: (row?: any) => void;
	/**Sets an event to be handled on row state change */
	handleRowChange?: (rowState: InputsRowChangeState) => void;
}

// export interface RadioInputData {
// 	[key: string]: boolean;
// 	// id: string;
// 	// checked: boolean;
// }

export interface RadioInputData {
	selectedId?: string;
	isDisabled?: boolean;
	// id: string;
}

interface InputsRowState {
	inputsState: RadioInputData;
}

type Props = InputsRowProps & RouteComponentProps;

class InputsRowComponent extends React.PureComponent<Props, InputsRowState> {
	public constructor(props: Props) {
		super(props);
		const {
			withCheckbox,
			columns,
			rowImage,
			withSuffix,
			withEmptySpaceSuffix,
			withImage,
			onClick,
			onDetailsClick,
			rowId,
			row,
			columnsWidth,
			isBold,
			isSelected,
		} = this.props;

		let inputsState: RadioInputData = {};

		if (columns) {
			// const cellData: InputsRowCellValue = columns.find(c => (c.value as InputsRowCellValue).checked)?.value;

			const cellData: InputsRowCellValue = columns.find(c => (c.value as InputsRowCellValue).checked)?.value;
			//  ||
			// columns.find(c => (c.value as InputsRowCellValue).checked);

			const radioButtonElem = columns.find(c => (c.value as InputsRowCellValue).hasRadioButton);
			const isDisabled = (radioButtonElem?.value as InputsRowCellValue)?.isDisabled;

			// if (cellData !== undefined) {
			inputsState = {
				selectedId: cellData ? cellData.radioButtonValue : undefined,
				isDisabled: isDisabled ? true : false,
				// cellData.isDisabled ? true : false,
			};
			// }
		}

		this.state = {
			inputsState,
		};

		// window.scrollTo(0, 0);
	}

	render(): React.ReactNode {
		const {
			withCheckbox,
			columns,
			rowImage,
			withSuffix,
			withEmptySpaceSuffix,
			withImage,
			onClick,
			onDetailsClick,
			rowId,
			row,
			columnsWidth,
			isBold,
		} = this.props;
		const { inputsState } = this.state;

		return (
			<>
				{/* <li className="ds-table-cell"> */}
				{columns &&
					columns.map(
						(column: TableColumn, index: number): JSX.Element => {
							const cellValue = column.value as InputsRowCellValue;

							return (
								// <React.Fragment key={CoreHelper.guid() || index}>
								<div
									key={CoreHelper.guid() || index}
									className={`it-table-cell${
										index === 0
											? ' it-table-cell-mobile-header cell-alignLeft cell-mobile-alignCenter'
											: ' cell-alignCenter cell-mobile-alignLeft'
									}`}

									// ${
									// 	columnsWidth && columnsWidth[index] === ColType.small
									// 		? 'flex-column table-small-cell'
									// 		: ''
									// }${
									// 	columnsWidth && columnsWidth[index] === ColType.big
									// 		? 'flex-column table-big-cell'
									// 		: ''
									// }${
									// 	columnsWidth && columnsWidth[index] === ColType.normal
									// 		? 'flex-column table-normal-cell'
									// 		: ''
									// }${
									// 	columnsWidth && columnsWidth[index] === ColType.currency
									// 		? 'flex-column table-normal-currency-cell'
									// 		: ''
									// }
									// 	${columnsWidth && columnsWidth[index] === ColType.extraBig ? 'flex-column table-extra-big-cell' : ''}`}
								>
									{/* {withImage && index + 1 === 1 && (
												<div className="table-checkbox-cell">
													<Image src={rowImage} alt="" width="32px" height="32px" />
												</div>
											)} */}

									{cellValue && cellValue.hasRadioButton === true && (
										<Checkbox
											id={CoreHelper.guid()}
											labelText={cellValue.radioButtonLabel}
											// value={cellValue.radioButtonValue ? cellValue.radioButtonValue : ''}
											isChecked={inputsState.selectedId === cellValue.radioButtonValue}
											disabled={inputsState.isDisabled}
											handleChange={
												!inputsState.isDisabled
													? (e: React.ChangeEvent<HTMLInputElement>): void => {
															// const newInputsState = {
															// 	...inputsState,
															// 	...{
															// 		[cellValue.radioButtonValue as string]: e.target
															// 			.checked,
															// 	},
															// };

															const newInputsState = {
																selectedId: e.target.checked
																	? cellValue.radioButtonValue
																	: undefined,
															};

															if (newInputsState.selectedId !== inputsState.selectedId) {
																this.setState({
																	inputsState: newInputsState,
																});

																this.handleCellChange(newInputsState);
															}
													  }
													: undefined
											}
										/>
									)}

									{cellValue && cellValue.text && (
										<p className={`${isBold ? 'table-row-bold' : 'table-row-normal'}`}>
											{cellValue.text}
										</p>
									)}
								</div>

								// {/* {index + 1 === columns.length && withSuffix === true && (
								// 		<div
								// 			onClick={(): void => {
								// 				onDetailsClick
								// 					? onDetailsClick(row)
								// 					: this.handleDetailsClick(rowId);
								// 			}}
								// 			className="ds-table-cell-detail flex-column ic-setatabela-after clickable table-small-cell"
								// 		></div>
								// 	)} */}
								// </React.Fragment>
							);
						}
					)}
				{/* </li> */}
			</>
		);
	}

	private handleCellChange(inputsState: RadioInputData) {
		const { rowId, handleRowChange } = this.props;

		handleRowChange &&
			handleRowChange({
				rowId,
				inputsState,
			});
	}

	// private readonly handleDetailsClick = (rowId: string): void => {
	// 	const { pathToRedirect, history } = this.props;

	// 	history.push(`${pathToRedirect}/${rowId}`);
	// };
}

export interface InputsRowChangeState {
	rowId: string;
	inputsState: RadioInputData;
}

// export const createInputsState = (inputsState: RadioInputData, columns: TableColumn[]): RadioInputData => {
// 	inputsState = columns.reduce<RadioInputData>((p, c): RadioInputData => {
// 		const cell = c.value as InputsRowCellValue;
// 		// if ((c.value as InputsRowCellValue).hasRadioButton) {
// 		return Object.assign(
// 			p,
// 			cell.hasRadioButton ? cell /*{ [cell.radioButtonValue as string]: cell.checked ? true : false }*/ : {}
// 		);
// 		// }
// 		// return {
// 		// 	id: cell.radioButtonValue ?? '',
// 		// 	checked: cell.checked ?? false,
// 		// };
// 	}, {});
// 	return inputsState;
// };

export interface InputsRowCellValue {
	// id?: string;
	text?: string; // Title
	hasRadioButton?: boolean;
	radioButtonValue?: string; // CONSULTS
	radioButtonLabel?: string;
	checked?: boolean;
	isDisabled?: boolean;
	// handleChange?: (e: React.ChangeEvent<any>) => void;
}

export const InputsRow = WithCoreProps<InputsRowProps>(withRouter(InputsRowComponent));
